import React, { Component } from "react";
import "../styles/App.css";
import { Link } from "react-router-dom";
import { FaGooglePlay, FaApple } from "react-icons/fa";

export class App extends Component {
  render() {
    return (
      <div>
        <section className="app__section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12 mx-auto">
                <h2 className="app__title">GET THE APP FROM</h2>
                <div className="mt-5">
                  <Link
                    to="#"
                    className="d-inline-flex align-items-center app-btn"
                  >
                    <div>
                      <FaGooglePlay
                        style={{ padding: "0.6rem", fontSize: "50px" }}
                      />
                    </div>
                    <div>
                      <span className="btn-label">Get it on</span>
                      <span className="btn-caption">Google Play</span>
                    </div>
                  </Link>
                  <Link
                    to="#"
                    className="d-inline-flex align-items-center app-btn"
                  >
                    <div>
                      <FaApple
                        style={{ padding: "0.6rem", fontSize: "50px" }}
                      />
                    </div>
                    <div>
                      <span className="btn-label">Download on the</span>
                      <span className="btn-caption">App Store</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default App;
